<template lang="pug">
section
  div
    | There are several types of companies
    | and each type will require
    | different supporting documents
    | to be submitted.
    | Normally, a company will need
    | to accumulate at least four pieces
    | of evidence from the
    |
    a(
      href="https://www.gov.uk/government/collections/sponsorship-information-for-employers-and-educators ",
      target="_blank"
    )
      | Appendix A
    |
    | list to support their application.

  br

  div
    | Typically for the average
    | private limited company
    | the following are the easiest to find,
    | although this is very much case by case:

  br

  ul
    li
      | Recent business bank statement
      | or a letter from the UK bank
      | which outlines the dealings
      | they have had with the organisation;
    li
      | Evidence that the sponsor
      | has coverage for employer’s
      | liability insurance up to £5 million;
    li
      | Proof of ownership
      | or rental agreement
      | for the business premises;
    li
      | Certificate of VAT registration;
    li
      | Evidence of registration
      | as an employer
      | with HM Revenue and Custom;
    li
      | Latest annual accounts.

  br

  div
    | 🚀
    |
    span(style="background: #ccedeb")
      | Based on your specific circumstances,
      | Nation.better will provide
      | a comprehensive list of documents
      | that are required to support your application!
</template>

<script>
export default {
  name: "prepare_ao_docs",
};
</script>